import { usePermission } from 'app/services';

const Protect = (props) => {
  const { permissions, renderPermitted, renderForbidden } = props;
  const permitted = usePermission(permissions);

  return permitted ? renderPermitted() : renderForbidden();
};

export default Protect;
